import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreateDeviceCollectionDocument } from './create.generated';

export const useCreateDeviceCollection = (
  options: ApiOptions<typeof CreateDeviceCollectionDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(CreateDeviceCollectionDocument, {
    ...useNotifications(CreateDeviceCollectionDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.device_filters.create_success'),
    }),
    ...options,
  });
};
